import * as Types from '../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FaxListFragment = { __typename?: 'Fax', incomingEmailAddress?: string | null, number?: { __typename?: 'Number', shortNumber?: string | null, e164?: any | null } | null };

export type FaxLimitQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type FaxLimitQuery = { __typename?: 'Query', domainAllocation: { __typename?: 'DomainAllocations', services: { __typename?: 'ServiceDomainAllocationsInfo', fax: { __typename?: 'DomainAllocationInfo', domainAllocated: number, domainUsed: number, remaining: number, allocationIncrementError?: { __typename?: 'Error', type: string, context?: string | null } | null } } } };

export type GetRandomPasswordQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetRandomPasswordQuery = { __typename?: 'Query', sipUser?: { __typename?: 'SIPUser', password: string } | null };

export type ExtensionsQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type ExtensionsQuery = { __typename?: 'Query', users?: { __typename?: 'UserList', items: Array<{ __typename?: 'User', id: number, displayName: string, notificationEmail?: string | null, number?: { __typename?: 'Number', shortNumber?: string | null } | null } | null> } | null };

export type FaxesEmailsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type FaxesEmailsQuery = { __typename?: 'Query', faxesEmails?: { __typename?: 'FaxesEmailList', items: Array<{ __typename?: 'FaxesEmail', extensionId: number } | null> } | null };

export type FaxRelatedDataQueryVariables = Types.Exact<{
  faxId: Types.Scalars['Int']['input'];
}>;


export type FaxRelatedDataQuery = { __typename?: 'Query', relatedData: { __typename?: 'References', overrideCaller: Array<{ __typename?: 'User', id: number, displayName: string, number?: { __typename?: 'Number', shortNumber?: string | null } | null }>, ivrActions: Array<{ __typename?: 'IvrAction', id: number, button: number, ivrProfile?: { __typename?: 'IvrProfile', name: string, ivr?: { __typename?: 'Ivr', id: number, name: string, number?: { __typename?: 'Number', shortNumber?: string | null } | null } | null } | null }> } };

export type GetTargetsQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type GetTargetsQuery = { __typename?: 'Query', gateways?: { __typename?: 'GatewayList', items: Array<{ __typename?: 'Gateway', id: number, displayName: string, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null } | null> } | null, faxes?: { __typename?: 'FaxList', items: Array<{ __typename?: 'Fax', id: number, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null } | null> } | null, groups?: { __typename?: 'GroupList', items: Array<{ __typename?: 'Group', id: number, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null } | null> } | null, users?: { __typename?: 'UserList', items: Array<{ __typename?: 'User', id: number, displayName: string, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null } | null> } | null };

export type FaxQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type FaxQuery = { __typename?: 'Query', faxes?: { __typename?: 'FaxList', items: Array<{ __typename?: 'Fax', id: number, headerInfo: string, headerNumber: string, incomingEmailAddress?: string | null, senderEmailAddress?: string | null, password: string, notifyUnsuccessfulReceiving: boolean, outgoingCallBarringAdmin?: any | null, outgoingCallBarringOperator?: any | null, number?: { __typename?: 'Number', nonPaymentBlockingType: Types.NonPaymentBlockingType } | null } | null> } | null, faxesEmails?: { __typename?: 'FaxesEmailList', items: Array<{ __typename?: 'FaxesEmail', id: number, extensionId: number, enableBodyProcess?: boolean | null, enableProgressFeedback?: boolean | null, extension?: { __typename?: 'User', displayName: string, notificationEmail?: string | null, number?: { __typename?: 'Number', shortNumber?: string | null } | null } | null } | null> } | null };

export type FaxRecordListQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  interval?: Types.InputMaybe<Types.FaxRecordsInterval>;
  direction: Types.FaxDirection;
}>;


export type FaxRecordListQuery = { __typename?: 'Query', faxRecords?: { __typename?: 'FaxRecords', records: Array<{ __typename?: 'FaxRecord', time: any, remote: string, direction: Types.FaxDirection, status: Types.FaxStatus, pages: number, subject: string }> } | null };

export const FaxListFragmentDoc = gql`
    fragment FaxList on Fax {
  number {
    shortNumber
    e164
  }
  incomingEmailAddress
}
    `;
export const FaxLimitDocument = gql`
    query FaxLimit($domainId: Int!) {
  domainAllocation(domainId: $domainId) {
    services {
      fax {
        domainAllocated
        domainUsed
        remaining
        allocationIncrementError {
          type
          context
        }
      }
    }
  }
}
    `;

/**
 * __useFaxLimitQuery__
 *
 * To run a query within a React component, call `useFaxLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `useFaxLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFaxLimitQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useFaxLimitQuery(baseOptions: Apollo.QueryHookOptions<FaxLimitQuery, FaxLimitQueryVariables> & ({ variables: FaxLimitQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FaxLimitQuery, FaxLimitQueryVariables>(FaxLimitDocument, options);
      }
export function useFaxLimitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FaxLimitQuery, FaxLimitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FaxLimitQuery, FaxLimitQueryVariables>(FaxLimitDocument, options);
        }
export function useFaxLimitSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FaxLimitQuery, FaxLimitQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FaxLimitQuery, FaxLimitQueryVariables>(FaxLimitDocument, options);
        }
export type FaxLimitQueryHookResult = ReturnType<typeof useFaxLimitQuery>;
export type FaxLimitLazyQueryHookResult = ReturnType<typeof useFaxLimitLazyQuery>;
export type FaxLimitSuspenseQueryHookResult = ReturnType<typeof useFaxLimitSuspenseQuery>;
export type FaxLimitQueryResult = Apollo.QueryResult<FaxLimitQuery, FaxLimitQueryVariables>;
export const GetRandomPasswordDocument = gql`
    query GetRandomPassword {
  sipUser {
    password
  }
}
    `;

/**
 * __useGetRandomPasswordQuery__
 *
 * To run a query within a React component, call `useGetRandomPasswordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRandomPasswordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRandomPasswordQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRandomPasswordQuery(baseOptions?: Apollo.QueryHookOptions<GetRandomPasswordQuery, GetRandomPasswordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRandomPasswordQuery, GetRandomPasswordQueryVariables>(GetRandomPasswordDocument, options);
      }
export function useGetRandomPasswordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRandomPasswordQuery, GetRandomPasswordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRandomPasswordQuery, GetRandomPasswordQueryVariables>(GetRandomPasswordDocument, options);
        }
export function useGetRandomPasswordSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRandomPasswordQuery, GetRandomPasswordQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRandomPasswordQuery, GetRandomPasswordQueryVariables>(GetRandomPasswordDocument, options);
        }
export type GetRandomPasswordQueryHookResult = ReturnType<typeof useGetRandomPasswordQuery>;
export type GetRandomPasswordLazyQueryHookResult = ReturnType<typeof useGetRandomPasswordLazyQuery>;
export type GetRandomPasswordSuspenseQueryHookResult = ReturnType<typeof useGetRandomPasswordSuspenseQuery>;
export type GetRandomPasswordQueryResult = Apollo.QueryResult<GetRandomPasswordQuery, GetRandomPasswordQueryVariables>;
export const ExtensionsDocument = gql`
    query Extensions($domainId: Int!) {
  users(domainId: $domainId) {
    items {
      id
      displayName
      notificationEmail
      number {
        shortNumber
      }
    }
  }
}
    `;

/**
 * __useExtensionsQuery__
 *
 * To run a query within a React component, call `useExtensionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExtensionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExtensionsQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useExtensionsQuery(baseOptions: Apollo.QueryHookOptions<ExtensionsQuery, ExtensionsQueryVariables> & ({ variables: ExtensionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExtensionsQuery, ExtensionsQueryVariables>(ExtensionsDocument, options);
      }
export function useExtensionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExtensionsQuery, ExtensionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExtensionsQuery, ExtensionsQueryVariables>(ExtensionsDocument, options);
        }
export function useExtensionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExtensionsQuery, ExtensionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExtensionsQuery, ExtensionsQueryVariables>(ExtensionsDocument, options);
        }
export type ExtensionsQueryHookResult = ReturnType<typeof useExtensionsQuery>;
export type ExtensionsLazyQueryHookResult = ReturnType<typeof useExtensionsLazyQuery>;
export type ExtensionsSuspenseQueryHookResult = ReturnType<typeof useExtensionsSuspenseQuery>;
export type ExtensionsQueryResult = Apollo.QueryResult<ExtensionsQuery, ExtensionsQueryVariables>;
export const FaxesEmailsDocument = gql`
    query FaxesEmails {
  faxesEmails {
    items {
      extensionId
    }
  }
}
    `;

/**
 * __useFaxesEmailsQuery__
 *
 * To run a query within a React component, call `useFaxesEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFaxesEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFaxesEmailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFaxesEmailsQuery(baseOptions?: Apollo.QueryHookOptions<FaxesEmailsQuery, FaxesEmailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FaxesEmailsQuery, FaxesEmailsQueryVariables>(FaxesEmailsDocument, options);
      }
export function useFaxesEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FaxesEmailsQuery, FaxesEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FaxesEmailsQuery, FaxesEmailsQueryVariables>(FaxesEmailsDocument, options);
        }
export function useFaxesEmailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FaxesEmailsQuery, FaxesEmailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FaxesEmailsQuery, FaxesEmailsQueryVariables>(FaxesEmailsDocument, options);
        }
export type FaxesEmailsQueryHookResult = ReturnType<typeof useFaxesEmailsQuery>;
export type FaxesEmailsLazyQueryHookResult = ReturnType<typeof useFaxesEmailsLazyQuery>;
export type FaxesEmailsSuspenseQueryHookResult = ReturnType<typeof useFaxesEmailsSuspenseQuery>;
export type FaxesEmailsQueryResult = Apollo.QueryResult<FaxesEmailsQuery, FaxesEmailsQueryVariables>;
export const FaxRelatedDataDocument = gql`
    query FaxRelatedData($faxId: Int!) {
  relatedData(id: $faxId, numberType: FAX) {
    overrideCaller {
      id
      displayName
      number {
        shortNumber
      }
    }
    ivrActions {
      id
      button
      ivrProfile {
        name
        ivr {
          id
          name
          number {
            shortNumber
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFaxRelatedDataQuery__
 *
 * To run a query within a React component, call `useFaxRelatedDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useFaxRelatedDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFaxRelatedDataQuery({
 *   variables: {
 *      faxId: // value for 'faxId'
 *   },
 * });
 */
export function useFaxRelatedDataQuery(baseOptions: Apollo.QueryHookOptions<FaxRelatedDataQuery, FaxRelatedDataQueryVariables> & ({ variables: FaxRelatedDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FaxRelatedDataQuery, FaxRelatedDataQueryVariables>(FaxRelatedDataDocument, options);
      }
export function useFaxRelatedDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FaxRelatedDataQuery, FaxRelatedDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FaxRelatedDataQuery, FaxRelatedDataQueryVariables>(FaxRelatedDataDocument, options);
        }
export function useFaxRelatedDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FaxRelatedDataQuery, FaxRelatedDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FaxRelatedDataQuery, FaxRelatedDataQueryVariables>(FaxRelatedDataDocument, options);
        }
export type FaxRelatedDataQueryHookResult = ReturnType<typeof useFaxRelatedDataQuery>;
export type FaxRelatedDataLazyQueryHookResult = ReturnType<typeof useFaxRelatedDataLazyQuery>;
export type FaxRelatedDataSuspenseQueryHookResult = ReturnType<typeof useFaxRelatedDataSuspenseQuery>;
export type FaxRelatedDataQueryResult = Apollo.QueryResult<FaxRelatedDataQuery, FaxRelatedDataQueryVariables>;
export const GetTargetsDocument = gql`
    query GetTargets($domainId: Int!) {
  gateways(domainId: $domainId) {
    items {
      id
      displayName
      number {
        id
        shortNumber
      }
    }
  }
  faxes(domainId: $domainId) {
    items {
      id
      number {
        id
        shortNumber
      }
    }
  }
  groups(domainId: $domainId) {
    items {
      id
      number {
        id
        shortNumber
      }
    }
  }
  users(domainId: $domainId) {
    items {
      id
      displayName
      number {
        id
        shortNumber
      }
    }
  }
}
    `;

/**
 * __useGetTargetsQuery__
 *
 * To run a query within a React component, call `useGetTargetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTargetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTargetsQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useGetTargetsQuery(baseOptions: Apollo.QueryHookOptions<GetTargetsQuery, GetTargetsQueryVariables> & ({ variables: GetTargetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTargetsQuery, GetTargetsQueryVariables>(GetTargetsDocument, options);
      }
export function useGetTargetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTargetsQuery, GetTargetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTargetsQuery, GetTargetsQueryVariables>(GetTargetsDocument, options);
        }
export function useGetTargetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTargetsQuery, GetTargetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTargetsQuery, GetTargetsQueryVariables>(GetTargetsDocument, options);
        }
export type GetTargetsQueryHookResult = ReturnType<typeof useGetTargetsQuery>;
export type GetTargetsLazyQueryHookResult = ReturnType<typeof useGetTargetsLazyQuery>;
export type GetTargetsSuspenseQueryHookResult = ReturnType<typeof useGetTargetsSuspenseQuery>;
export type GetTargetsQueryResult = Apollo.QueryResult<GetTargetsQuery, GetTargetsQueryVariables>;
export const FaxDocument = gql`
    query Fax($id: Int!) {
  faxes(id: $id) {
    items {
      id
      headerInfo
      headerNumber
      number {
        nonPaymentBlockingType
      }
      incomingEmailAddress
      senderEmailAddress
      password
      notifyUnsuccessfulReceiving
      outgoingCallBarringAdmin
      outgoingCallBarringOperator
    }
  }
  faxesEmails(faxIdOrNone: $id) {
    items {
      id
      extensionId
      enableBodyProcess
      enableProgressFeedback
      extension {
        displayName
        number {
          shortNumber
        }
        notificationEmail
      }
    }
  }
}
    `;

/**
 * __useFaxQuery__
 *
 * To run a query within a React component, call `useFaxQuery` and pass it any options that fit your needs.
 * When your component renders, `useFaxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFaxQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFaxQuery(baseOptions: Apollo.QueryHookOptions<FaxQuery, FaxQueryVariables> & ({ variables: FaxQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FaxQuery, FaxQueryVariables>(FaxDocument, options);
      }
export function useFaxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FaxQuery, FaxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FaxQuery, FaxQueryVariables>(FaxDocument, options);
        }
export function useFaxSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FaxQuery, FaxQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FaxQuery, FaxQueryVariables>(FaxDocument, options);
        }
export type FaxQueryHookResult = ReturnType<typeof useFaxQuery>;
export type FaxLazyQueryHookResult = ReturnType<typeof useFaxLazyQuery>;
export type FaxSuspenseQueryHookResult = ReturnType<typeof useFaxSuspenseQuery>;
export type FaxQueryResult = Apollo.QueryResult<FaxQuery, FaxQueryVariables>;
export const FaxRecordListDocument = gql`
    query FaxRecordList($id: Int!, $interval: FaxRecordsInterval, $direction: FaxDirection!) {
  faxRecords(id: $id, interval: $interval, direction: $direction) {
    records {
      time
      remote
      direction
      status
      pages
      subject
    }
  }
}
    `;

/**
 * __useFaxRecordListQuery__
 *
 * To run a query within a React component, call `useFaxRecordListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFaxRecordListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFaxRecordListQuery({
 *   variables: {
 *      id: // value for 'id'
 *      interval: // value for 'interval'
 *      direction: // value for 'direction'
 *   },
 * });
 */
export function useFaxRecordListQuery(baseOptions: Apollo.QueryHookOptions<FaxRecordListQuery, FaxRecordListQueryVariables> & ({ variables: FaxRecordListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FaxRecordListQuery, FaxRecordListQueryVariables>(FaxRecordListDocument, options);
      }
export function useFaxRecordListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FaxRecordListQuery, FaxRecordListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FaxRecordListQuery, FaxRecordListQueryVariables>(FaxRecordListDocument, options);
        }
export function useFaxRecordListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FaxRecordListQuery, FaxRecordListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FaxRecordListQuery, FaxRecordListQueryVariables>(FaxRecordListDocument, options);
        }
export type FaxRecordListQueryHookResult = ReturnType<typeof useFaxRecordListQuery>;
export type FaxRecordListLazyQueryHookResult = ReturnType<typeof useFaxRecordListLazyQuery>;
export type FaxRecordListSuspenseQueryHookResult = ReturnType<typeof useFaxRecordListSuspenseQuery>;
export type FaxRecordListQueryResult = Apollo.QueryResult<FaxRecordListQuery, FaxRecordListQueryVariables>;